import { render, staticRenderFns } from "./gGridview.vue?vue&type=template&id=ac52ef70&"
import script from "./gGridview.vue?vue&type=script&lang=js&"
export * from "./gGridview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gGridview.vue"
export default component.exports